let intial_state = [
    // {
    //   id:1,
    //   name:"آزمون فلسفه زندگی",
    //   time:'11:00'
    // },
    // {
    //   id:2,
    //   name:"آزمون موسیقی شناسی",
    //   time:'18:00'
    // },
];

const CalendarEventListReducer=(state =intial_state, action)=>{
  switch (action.type) {
    case "showEvent":
      return action.exams
    default:
      return state;
  }
}

export default CalendarEventListReducer;